<ion-card>
  <ion-card-header>
    <ion-card-title>Könyvelés</ion-card-title>
  </ion-card-header>
  <ion-card-content>


    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-select aria-label="Napló" interface="popover" placeholder="" label="Napló"
            (ionChange)="fotipusvalt($event)" label-placement="stacked" fill="outline"
            value="1"><!-- style="min-height: 56px; border: 0; cursor: pointer"-->
            <ion-select-option value="1">Szállító</ion-select-option>
            <ion-select-option value="2">Vevő</ion-select-option>
            <ion-select-option value="2">Bank</ion-select-option>
            <ion-select-option value="2">Pénztár</ion-select-option>
            <ion-select-option value="2">Vegyes</ion-select-option>
            <ion-select-option value="2">Nyitó</ion-select-option>
            <ion-select-option value="2">Záró</ion-select-option>
          </ion-select>
        </ion-col>
        <ion-col>
          <ion-button color="light" size="large" style="margin-top:0;" title="Egyenleg">
            <ion-icon slot="icon-only" name="list"></ion-icon>

          </ion-button>
          <ion-button color="light" size="large" style="margin-top:0" title="Bizonylat kiállítása">
            <ion-icon slot="icon-only" name="people"></ion-icon>

          </ion-button>
          <ion-button color="light" size="large" style="margin-top:0" title="Bizonylat kiállítása">
            <ion-icon slot="icon-only" name="person-add"></ion-icon>

          </ion-button>
          <ion-button color="light" size="large" style="margin-top:0" title="Bizonylat kiállítása">
            <ion-icon slot="icon-only" name="logo-euro"></ion-icon>

          </ion-button>
          <ion-button color="light" size="large" style="margin-top:0" title="Bizonylat kiállítása">
            <ion-icon slot="icon-only" name="swap-horizontal"></ion-icon>

          </ion-button>
          <ion-button color="light" size="large" style="margin-top:0" title="Bizonylat kiállítása">
            <ion-icon slot="icon-only" name="enter"></ion-icon>

          </ion-button>
          <ion-button color="light" size="large" style="margin-top:0" title="Bizonylat kiállítása">
            <ion-icon slot="icon-only" name="exit"></ion-icon>

          </ion-button>
        </ion-col>
      </ion-row>
      <hr>
      <ion-row>
        <ion-col>

          <ion-select aria-label="Fizetési mód" interface="popover" placeholder="" label="Fizetési mód"
            (ionChange)="fotipusvalt($event)" label-placement="stacked" fill="outline"
            value="1"><!-- style="min-height: 56px; border: 0; cursor: pointer"-->
            <ion-select-option value="1">Szállító</ion-select-option>
            <ion-select-option value="2">Vevő</ion-select-option>
            <ion-select-option value="2">Bank</ion-select-option>
            <ion-select-option value="2">Pénztár</ion-select-option>
            <ion-select-option value="2">Vegyes</ion-select-option>
            <ion-select-option value="2">Nyitó</ion-select-option>
            <ion-select-option value="2">Záró</ion-select-option>
          </ion-select>

        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-input label="Teljesítés" label-placement="stacked" fill="outline" placeholder="" type="date"
            max="3000-12-31" formControlName="szul_datum"><ion-icon slot="start" name="time"
              aria-hidden="true"></ion-icon></ion-input>
        </ion-col><ion-col>
          <ion-input label="Kelt" label-placement="stacked" fill="outline" placeholder="" type="date" max="3000-12-31"
            formControlName="szul_datum"><ion-icon slot="start" name="time" aria-hidden="true"></ion-icon></ion-input>
        </ion-col><ion-col>
          <ion-input label="Esedékesség" label-placement="stacked" fill="outline" placeholder="" type="date"
            max="3000-12-31" formControlName="szul_datum"><ion-icon slot="start" name="time"
              aria-hidden="true"></ion-icon></ion-input>
        </ion-col><ion-col>
          <ion-input label="Kiegyenlítve" label-placement="stacked" fill="outline" placeholder="" type="date"
            max="3000-12-31" formControlName="szul_datum" [disabled]="true"><ion-icon slot="start" name="time"
              aria-hidden="true"></ion-icon></ion-input>

        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-input label="Bizonylat" label-placement="stacked" fill="outline" placeholder="">
            <ion-icon slot="start" name="school" aria-hidden="true"></ion-icon></ion-input><br>

        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="border-right: 2px solid black;border-top:2px solid black;">
          <ion-segment value="default" color="primary">
            <ion-segment-button value="default">
              <ion-label>Tartozik</ion-label>
            </ion-segment-button>
            <ion-segment-button value="segment">
              <ion-label>Követel</ion-label>
            </ion-segment-button>
          </ion-segment><br>
          <div
            class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
            <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
              <div class="input-outline-container sc-ion-input-md">
                <div class="input-outline-start sc-ion-input-md"></div>
                <div class="input-outline-notch sc-ion-input-md">
                  <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Főkönyvi szám</div>
                </div>
                <div class="input-outline-end sc-ion-input-md"></div>
              </div>
              <div class="label-text-wrapper sc-ion-input-md">
                <div class="label-text sc-ion-input-md">Főkönyvi szám</div>
              </div>
              <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                <!--ion-icon name="balloon" aria-hidden="true"></ion-icon-->
                <ng-select [items]="szamlaTukor" bindLabel="megjelen" bindValue="fokonyvi_szam" groupBy="csoport"
                  appendTo="body" [multiple]="false" [closeOnSelect]="true" [(ngModel)]="elsoMezo"
                  (change)="fotipusvalt($event)">
                </ng-select>
              </div>
            </label>
          </div>
          <br>
        </ion-col>
        <ion-col style="border-top:2px solid black;">
          <ion-segment value="segment" color="primary">
            <ion-segment-button value="default">
              <ion-label>Tartozik</ion-label>
            </ion-segment-button>
            <ion-segment-button value="segment">
              <ion-label>Követel</ion-label>
            </ion-segment-button>
          </ion-segment><br>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>


          <ng-container *ngIf="egyenleg">
            <ngx-datatable (select)="onSelect($event)"
              class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz selectable checkbox-selection"
              [rows]="egyenleg" [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowHeight]="'auto'"
              [rowClass]="getRowClass" [sorts]="[
  { prop: 'created_at', dir: 'desc' },
  { prop: 'updated_at', dir: 'desc' },
  { prop: 'priority', dir: 'desc' },
  { prop: 'deadline', dir: 'desc' }
]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
              <ngx-datatable-column name="Fők.szám" prop="csalad_reszletek">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template
                  style="overflow-wrap:break-word">
                  <b class="mobil">Család</b>
                  <span *ngIf="value"><span *ngFor="let item of JSON.parse(value)">{{ item.nev }} <span
                        *ngIf="item.type == 'szulo'">&lt;gondviselő&gt;</span><span
                        *ngIf="item.type != 'szulo'">&lt;tanuló&gt;</span><br> </span></span>

                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Megnevezés" prop="egyenleg">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  <b class="mobil">Egyenleg</b>
                  <span>{{ value }} Ft</span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Tartozik" prop="egyenleg">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  <b class="mobil">Egyenleg</b>
                  <span>{{ value }} Ft</span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Fők.szám" prop="csalad_reszletek">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template
                  style="overflow-wrap:break-word">
                  <b class="mobil">Család</b>
                  <span *ngIf="value"><span *ngFor="let item of JSON.parse(value)">{{ item.nev }} <span
                        *ngIf="item.type == 'szulo'">&lt;gondviselő&gt;</span><span
                        *ngIf="item.type != 'szulo'">&lt;tanuló&gt;</span><br> </span></span>

                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Megnevezés" prop="egyenleg">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  <b class="mobil">Egyenleg</b>
                  <span>{{ value }} Ft</span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Követel" prop="egyenleg">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  <b class="mobil">Egyenleg</b>
                  <span>{{ value }} Ft</span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="ÁFA" prop="egyenleg">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  <b class="mobil">Egyenleg</b>
                  <span>{{ value }} Ft</span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Műveletek">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template let-i="rowIndex">
                  <b class="mobil">Műveletek</b>
                  <ion-button color="primary" size="small" style="margin-top:0" title="Egyenleg"
                    (click)="initModal(JSON.parse(row.users)[0],egyenleg.indexOf(row))">
                    <ion-icon slot="icon-only" name="eye"></ion-icon>

                  </ion-button>
                  <ion-button color="danger" size="small" style="margin-top:0" title="Bizonylat kiállítása"
                    (click)="initModal3(JSON.parse(row.users)[0],egyenleg.indexOf(row))">
                    <ion-icon slot="icon-only" name="trash"></ion-icon>

                  </ion-button>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </ng-container>



        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>

<ion-modal class="" style="z-index: 1000" #tetelmodal trigger="tetel">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancel2()">Mégse</ion-button>
        </ion-buttons>
        <ion-title>Új Tétel</ion-title>
        <ion-buttons slot="end">
          <ion-button [disabled]="!tetel.valid" style="background: white; border-radius: 5px" (click)="confirm2()"
            [strong]="true" shape="round" color="secondary">Mentés</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" style="margin: auto;">
      <table style="width: 100%;" border="1">
        <thead>

        </thead>
        <tbody>
          <tr *ngFor="let item of JSON.parse(egyenleg[csegyenlegid].csalad_reszletek)">
            <td *ngIf="item.type=='szulo'">Gondviselő</td>
            <td *ngIf="item.type!='szulo'">Tanuló</td>
            <td>{{item.nev}}</td>
          </tr>
          <tr>
            <td [class]="csegyenleg.egyenleg >= 0 ? 'row-color-blue' : 'row-color-green'"><b>Egyenleg</b></td>
            <td [class]="csegyenleg.egyenleg >= 0 ? 'row-color-blue' : 'row-color-green'"><b>{{csegyenleg.egyenleg}}
                Ft</b></td>
          </tr>
        </tbody>
      </table>
      <hr>
      <form [formGroup]="tetel">
        <ion-select aria-label="Tétel típus" interface="popover" placeholder="" label="Tétel típus"
          (ionChange)="tipusValt()" formControlName="tipus" label-placement="stacked" fill="outline">
          <ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon>
          <ion-select-option value="Követelés alrendszerből">Követelés alrendszerből</ion-select-option>
          <ion-select-option value="Követelés">Követelés</ion-select-option>
          <ion-select-option value="Jóváírás alrendszerből">Jóváírás alrendszerből</ion-select-option>
          <ion-select-option value="Jóváírás">Jóváírás</ion-select-option>
          <ion-select-option value="Jóváírás követelésből" [disabled]="kovetelnullaz.length==0">Jóváírás
            követelésből</ion-select-option>
        </ion-select><br>
        <ion-select aria-label="Alrendszer" interface="popover" placeholder="" label="Alrendszer"
          *ngIf="tetel.value.tipus == 'Követelés alrendszerből' || tetel.value.tipus == 'Jóváírás alrendszerből'"
          formControlName="alrendszer" label-placement="stacked" fill="outline">
          <ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon>
          <ion-select-option value="Étkezés">Étkezés</ion-select-option>
        </ion-select><br
          *ngIf="tetel.value.tipus == 'Követelés alrendszerből' || tetel.value.tipus == 'Jóváírás alrendszerből'">
        <ion-row
          *ngIf="tetel.value.tipus == 'Követelés alrendszerből' || tetel.value.tipus == 'Jóváírás alrendszerből'">
          <ion-col>
            <ion-input label="Év" label-placement="stacked" fill="outline" placeholder="" type="number"
              formControlName="ev">
              <ion-icon slot="start" name="pricetag" aria-hidden="true"></ion-icon>
            </ion-input>
          </ion-col>
          <ion-col>
            <ion-select aria-label="Hónap" interface="popover" placeholder="" label="Hónap" (ionChange)="tipusValt()"
              formControlName="honap" label-placement="stacked"
              fill="outline"><!-- style="min-height: 56px; border: 0; cursor: pointer"-->
              <ion-select-option value="1">Január</ion-select-option>
              <ion-select-option value="2">Február</ion-select-option>
              <ion-select-option value="3">Március</ion-select-option>
              <ion-select-option value="4">Április</ion-select-option>
              <ion-select-option value="5">Május</ion-select-option>
              <ion-select-option value="6">Június</ion-select-option>
              <ion-select-option value="7">Július</ion-select-option>
              <ion-select-option value="8">Augusztus</ion-select-option>
              <ion-select-option value="9">Szeptember</ion-select-option>
              <ion-select-option value="10">Október</ion-select-option>
              <ion-select-option value="11">November</ion-select-option>
              <ion-select-option value="12">December</ion-select-option>
            </ion-select>
          </ion-col>
        </ion-row>
        <ion-select aria-label="Követelés" interface="popover" placeholder="" label="Követelés"
          *ngIf="tetel.value.tipus == 'Jóváírás követelésből'" (ionChange)="getAdatFromKoveteles($event)"
          formControlName="koveteles" label-placement="stacked" fill="outline">
          <ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon>
          <ion-select-option [value]="item" *ngFor="let item of kovetelnullaz">{{item.nev}} - {{item.osszeg}} Ft -
            {{item.date}}</ion-select-option>
        </ion-select>
        <br>
        <ion-input label="Megnevezés" label-placement="stacked" fill="outline" placeholder="" formControlName="nev">
          <ion-icon slot="start" name="pricetag" aria-hidden="true"></ion-icon>
        </ion-input><br>
        <ion-button (click)="getAdatFromAlrendszer()" expand="block" color="primary"
          *ngIf="tetel.value.tipus == 'Követelés alrendszerből' || tetel.value.tipus == 'Jóváírás alrendszerből'">Összeg
          lekérése</ion-button>

        <br
          *ngIf="tetel.value.tipus == 'Követelés alrendszerből' || tetel.value.tipus == 'Jóváírás alrendszerből' || tetel.value.tipus == 'Jóváírás követelésből'">
        <ion-input label="Összeg" label-placement="stacked" fill="outline" placeholder="" type="number"
          formControlName="osszeg"
          [disabled]="tetel.value.tipus == 'Követelés alrendszerből' || tetel.value.tipus == 'Jóváírás alrendszerből' || tetel.value.tipus == 'Jóváírás követelésből'">
          <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
          <span fill="clear" slot="end" aria-label="Show/hide">
            Ft
          </span>
        </ion-input><br>
        <div
          class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
          <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
            <div class="input-outline-container sc-ion-input-md">
              <div class="input-outline-start sc-ion-input-md"></div>
              <div class="input-outline-end sc-ion-input-md"></div>
            </div>
            <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">

              <ion-checkbox formControlName="dijbekero" labelPlacement="start" style="width: 100%; height: 100%;"
                [disabled]="false">
                Bizonylat kiállítása</ion-checkbox>
            </div>
          </label>
        </div><br>
        <ion-select aria-label="Bizonylattömb" interface="popover" placeholder="" label="Bizonylattömb"
          [disabled]="tetel.value.dijbekero != 'true'" formControlName="biztomb" label-placement="stacked"
          fill="outline">
          <ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon>
          <ion-select-option *ngFor="let t of tombok" [value]="t.id">{{t.elotag}}</ion-select-option>
        </ion-select><br>
      </form>
    </ion-content>
  </ng-template>
</ion-modal>



<ion-modal class="nagy" style="z-index: 1000" #bizonylatmodal trigger="bizonylat">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancel3()">Bezár</ion-button>
        </ion-buttons>
        <ion-title>Új bizonylat</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" style="margin: auto;">
      <app-szamlanew [csalad]="csegyenleg"></app-szamlanew>
    </ion-content>
  </ng-template>
</ion-modal>




<ion-modal class="nagy" style="z-index: 1000" #uzenetmodal trigger="uzenet">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancel()">Bezár</ion-button>
        </ion-buttons>
        <ion-title>Egyenlegközlő</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <table style="width: 100%;" border="1">
        <thead>

        </thead>
        <tbody>
          <tr *ngFor="let item of JSON.parse(egyenleg[csegyenlegid].csalad_reszletek)">
            <td *ngIf="item.type=='szulo'">Gondviselő</td>
            <td *ngIf="item.type!='szulo'">Tanuló</td>
            <td>{{item.nev}}</td>
          </tr>
          <tr>
            <td [class]="csegyenleg.egyenleg >= 0 ? 'row-color-blue' : 'row-color-green'"><b>Egyenleg</b></td>
            <td [class]="csegyenleg.egyenleg >= 0 ? 'row-color-blue' : 'row-color-green'"><b>{{csegyenleg.egyenleg}}
                Ft</b></td>
          </tr>
        </tbody>
      </table>


      <!--ion-segment value="3" color="primary" [scrollable]="true" [(ngModel)]="segment">
        <ion-segment-button value="1" layout="icon-start">
          <ion-label>Követelések</ion-label>
          <ion-icon name="log-out"></ion-icon>
        </ion-segment-button>
        <ion-segment-button value="2" layout="icon-start">
          <ion-label>Jóváírások</ion-label>
          <ion-icon name="log-in"></ion-icon>
        </ion-segment-button>
        <ion-segment-button value="3" layout="icon-start">
          <ion-label>Összegzés</ion-label>
          <ion-icon name="add-circle"></ion-icon>
        </ion-segment-button>
      </ion-segment>
      <hr-->

      <form [formGroup]="form">
        <ion-grid>
          <!--ion-row *ngIf="segment=='1'">

            <ion-col>
              <div style="margin-top: 10px;">
                <ion-button color="primary" (click)="initModal2(csegyenlegid,0,'Követelés')">
                  <ion-icon slot="start" name="add"></ion-icon>
                  Új követelés
                </ion-button>
              </div>
              <ng-container>
                <ngx-datatable (select)="onSelect($event)"
                  class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz" [rows]="kovetel"
                  [sortType]="SortType.single" [columnMode]="ColumnMode.force"  [rowClass]="getRowClass"
                  [sorts]="[
  { prop: 'date', dir: 'desc' }
]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
                  <ngx-datatable-column name="Név" prop="nev">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Név</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Összeg" prop="osszeg">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Összeg</b>
                      {{ value }} Ft
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Modul" prop="alrendszer">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                      <b class="mobil">Modul</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Dátum" prop="date">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Dátum</b>
                      <span *ngIf="value">{{ value }}</span>
                    </ng-template>
                  </ngx-datatable-column>

                </ngx-datatable>
              </ng-container>

            </ion-col>
          </ion-row>



          <ion-row *ngIf="segment=='2'">
            <ion-col>
              <div style="margin-top: 10px;">
                <ion-button color="primary" (click)="initModal2(csegyenlegid,0,'Jóváírás')">
                  <ion-icon slot="start" name="add"></ion-icon>
                  Új jóváírás
                </ion-button>
              </div>
              <ng-container>
                <ngx-datatable (select)="onSelect($event)"
                  class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz" [rows]="jovair"
                  [sortType]="SortType.single" [columnMode]="ColumnMode.force"  [rowClass]="getRowClass"
                  [sorts]="[
        { prop: 'date', dir: 'desc' }
      ]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
                  <ngx-datatable-column name="Név" prop="nev">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Név</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Összeg" prop="osszeg">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Összeg</b>
                      {{ -value }} Ft
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Modul" prop="alrendszer">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                      <b class="mobil">Modul</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Dátum" prop="date">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Dátum</b>
                      <span *ngIf="value">{{ value }}</span>
                    </ng-template>
                  </ngx-datatable-column>

                </ngx-datatable>
              </ng-container>

            </ion-col>
          </ion-row-->



          <ion-row><!-- *ngIf="segment=='3'"-->
            <ion-col size="6">
              <!--div style="margin-top: 10px;">
                <ion-button color="primary" (click)="initModal2(csegyenlegid,0,'Követelés')">
                  <ion-icon slot="start" name="add"></ion-icon>
                  Új követelés
                </ion-button>
              </div-->
              <ng-container>
                <ngx-datatable (select)="onSelect($event)"
                  class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz" [rows]="kovetel"
                  [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowClass]="getRowClass" [sorts]="[
        { prop: 'date', dir: 'desc' }
      ]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
                  <ngx-datatable-column name="Név" prop="nev">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Név</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Összeg" prop="osszeg">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Összeg</b>
                      {{ value }} Ft
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Dátum" prop="date">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Dátum</b>
                      <span *ngIf="value">{{ value }}</span>
                    </ng-template>
                  </ngx-datatable-column>

                </ngx-datatable>
              </ng-container>

            </ion-col>
            <ion-col size="6">
              <!--div style="margin-top: 10px;">
                <ion-button color="success" (click)="initModal2(csegyenlegid,0,'Jóváírás')">
                  <ion-icon slot="start" name="add"></ion-icon>
                  Új jóváírás
                </ion-button>
              </div-->
              <ng-container>
                <ngx-datatable (select)="onSelect($event)"
                  class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz" [rows]="jovair"
                  [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowClass]="getRowClass" [sorts]="[
        { prop: 'date', dir: 'desc' }
      ]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
                  <ngx-datatable-column name="Név" prop="nev">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Név</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Összeg" prop="osszeg">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Összeg</b>
                      {{ value }} Ft
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Dátum" prop="date">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Dátum</b>
                      <span *ngIf="value">{{ value }}</span>
                    </ng-template>
                  </ngx-datatable-column>

                </ngx-datatable>
              </ng-container>

            </ion-col>
          </ion-row>





        </ion-grid>
      </form>

    </ion-content>
  </ng-template>
</ion-modal>